import axios from 'axios'
import {PostModel} from './BlogModels'

const API_URL = process.env.REACT_APP_API_URL

export const GET_BLOG_URL = `${API_URL}/get_blog`
export const GET_BLOG_DETAIL_URL = `${API_URL}/blog/slug`
export const GET_CATEGORY_POSTS_URL = `${API_URL}/blogs/category`

export function getPosts(type: string) {
  return axios.post<PostModel[]>(GET_BLOG_URL, {
    type: type,
  })
}

export function getBlogDetail(slug: string) {
  return axios.get<PostModel>(`${GET_BLOG_DETAIL_URL}/${slug}`)
}

export function getCategoryPosts(categorySlug: string) {
  return axios.get<PostModel[]>(`${GET_CATEGORY_POSTS_URL}/${categorySlug}`)
}
